import { useEffect, useState } from 'react';

const DURATION_SECONDS = 17 * 60 + 34; // 00:17:34
const TOTAL_SPOTS = 100;
const START_SPOTS_LEFT = 9;
const MIN_SPOTS_LEFT = 3;
const SECONDS_PER_SPOT = 95;

// Shared start time so every timer on the page stays in sync
const START = Date.now();

export function useOfferClock() {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const id = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(id);
  }, []);

  const elapsed = Math.max(0, Math.floor((now - START) / 1000));
  const remaining = DURATION_SECONDS - (elapsed % DURATION_SECONDS);

  const hours = Math.floor(remaining / 3600);
  const minutes = Math.floor((remaining % 3600) / 60);
  const seconds = remaining % 60;

  const spotsLeft = Math.max(MIN_SPOTS_LEFT, START_SPOTS_LEFT - Math.floor(elapsed / SECONDS_PER_SPOT));
  const filledPercent = ((TOTAL_SPOTS - spotsLeft) / TOTAL_SPOTS) * 100;

  return {
    hours: pad(hours),
    minutes: pad(minutes),
    seconds: pad(seconds),
    spotsLeft,
    totalSpots: TOTAL_SPOTS,
    filledPercent,
  };
}

function pad(value: number): string {
  return value.toString().padStart(2, '0');
}
